import { render } from "./EditProgram.vue?vue&type=template&id=bd6dde52&scoped=true"
import script from "./EditProgram.vue?vue&type=script&lang=js"
export * from "./EditProgram.vue?vue&type=script&lang=js"

import "./EditProgram.vue?vue&type=style&index=0&id=bd6dde52&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6dde52"]])

export default __exports__